/**
 * reportsApi.js
 * ─────────────────────────────────────────────────────────────────────────────
 * Frontend API client for the Project Management Reports & Analytics submodule.
 */

import axios from 'axios';

const BASE = '/project-management/reports';

const cleanParams = (params = {}) => {
    const cleaned = {};
    Object.entries(params).forEach(([key, val]) => {
        if (val !== null && val !== undefined && val !== '') {
            cleaned[key] = val;
        }
    });
    return cleaned;
};

export const getOverviewReport = async (params = {}) => {
    try {
        const response = await axios.get(`${BASE}/overview`, { params: cleanParams(params) });
        return response.data;
    } catch (err) {
        console.error('Error fetching overview report:', err);
        return { success: false, message: err?.message };
    }
};

export const getDailyActivityReport = async (params = {}) => {
    try {
        const response = await axios.get(`${BASE}/daily-activity`, { params: cleanParams(params) });
        return response.data;
    } catch (err) {
        console.error('Error fetching daily activity report:', err);
        return { success: false, message: err?.message };
    }
};

export const getProjectsReport = async (params = {}) => {
    try {
        const response = await axios.get(`${BASE}/projects`, { params: cleanParams(params) });
        return response.data;
    } catch (err) {
        console.error('Error fetching projects report:', err);
        return { success: false, message: err?.message };
    }
};

export const getTasksReport = async (params = {}) => {
    try {
        const response = await axios.get(`${BASE}/tasks`, { params: cleanParams(params) });
        return response.data;
    } catch (err) {
        console.error('Error fetching tasks report:', err);
        return { success: false, message: err?.message };
    }
};

export const getMilestonesReport = async (params = {}) => {
    try {
        const response = await axios.get(`${BASE}/milestones`, { params: cleanParams(params) });
        return response.data;
    } catch (err) {
        console.error('Error fetching milestones report:', err);
        return { success: false, message: err?.message };
    }
};

export const getTasksMilestonesReport = async (params = {}) => {
    try {
        const response = await axios.get(`${BASE}/tasks-milestones`, { params: cleanParams(params) });
        return response.data;
    } catch (err) {
        console.error('Error fetching tasks & milestones report:', err);
        return { success: false, message: err?.message };
    }
};

export const getTeamWorkloadReport = async (params = {}) => {
    try {
        const response = await axios.get(`${BASE}/team-workload`, { params: cleanParams(params) });
        return response.data;
    } catch (err) {
        console.error('Error fetching team workload report:', err);
        return { success: false, message: err?.message };
    }
};

export const getMeetingsReport = async (params = {}) => {
    try {
        const response = await axios.get(`${BASE}/meetings`, { params: cleanParams(params) });
        return response.data;
    } catch (err) {
        console.error('Error fetching meetings report:', err);
        return { success: false, message: err?.message };
    }
};

export const getForecastsReport = async (params = {}) => {
    try {
        const response = await axios.get(`${BASE}/forecasts`, { params: cleanParams(params) });
        return response.data;
    } catch (err) {
        console.error('Error fetching forecasts report:', err);
        return { success: false, message: err?.message };
    }
};

export const getAiSummary = async (params = {}) => {
    try {
        const response = await axios.get(`${BASE}/ai-summary`, { params: cleanParams(params) });
        return response.data;
    } catch (err) {
        console.error('Error fetching AI summary:', err);
        return { success: false, message: err?.message };
    }
};

export const refreshAiSummary = async (payload = {}) => {
    try {
        const response = await axios.post(`${BASE}/ai-summary/refresh`, cleanParams(payload));
        return response.data;
    } catch (err) {
        console.error('Error refreshing AI summary:', err);
        return { success: false, message: err?.message };
    }
};
